import React from "react";

export default function IconRecord() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 2.15C18.6962 2.0132 18.3588 1.9687 18.0299 2.02204C17.701 2.07537 17.395 2.22419 17.15 2.45L15 4.45V3C15 2.20435 14.6839 1.44129 14.1213 0.87868C13.5587 0.316071 12.7956 0 12 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V11C0 11.7956 0.316071 12.5587 0.87868 13.1213C1.44129 13.6839 2.20435 14 3 14H12C12.7956 14 13.5587 13.6839 14.1213 13.1213C14.6839 12.5587 15 11.7956 15 11V9.55L17.16 11.55C17.478 11.8378 17.8911 11.9981 18.32 12C18.558 11.9994 18.7932 11.9483 19.01 11.85C19.3049 11.7307 19.5576 11.5262 19.7357 11.2625C19.9139 10.9989 20.0094 10.6882 20.01 10.37V3.63C20.0086 3.31069 19.9116 2.99911 19.7316 2.73536C19.5516 2.47161 19.2968 2.26774 19 2.15V2.15Z" />
    </svg>
  );
}
